import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { HeaderDashboardComponent } from './components/header-dashboard/header-dashboard.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { createCustomElement } from '@angular/elements';
import { DialogModule } from 'app/dialog/dialog.module';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { RouterModule } from '@angular/router';



import { StoreModule } from '@ngrx/store';
import { DashboardEffects } from './features/dashboard.effects';
import * as fromDashboard from './features/dashboard.reducer';
import { SurveyEffects } from './features/survey.effects';
import * as fromSurvey from './features/survey.reducer'

import { IconModule } from 'app/icon/icon.module';
import  {ClipboardModule } from '@angular/cdk/clipboard';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { MdbChartModule } from 'mdb-angular-ui-kit/charts';

import { ChartComponent } from './components/chart/chart.component';
import { ReferAFriendComponent } from './components/refer-a-friend/refer-a-friend.component';
import { DashboardSwiperComponent } from './components/swiper/dashboard-swiper.component';
import { DashboardDonorTableComponent } from './components/dashboard-donor-table/dashboard-donor-table.component';
import { DashboardActionButtonsComponent } from './components/dashboard-action-buttons/dashboard-action-buttons.component';
import { DashboardGetStartButtonsComponent } from './components/dashboard-get-start-buttons/dashboard-get-start-buttons.component';
import { SharedLinkPopoverComponent } from './components/shared-link-popover/shared-link-popover.component';
import { EffectsModule } from '@ngrx/effects';
import { SurveyModalComponent } from './components/modals/survey-modal/survey-modal.component';
import { MdbRatingModule } from 'mdb-angular-ui-kit/rating';
import { ActionsPopoverSurveyComponent } from './components/actions-popover-survey/actions-popover-survey.component';
import { LetUsHelpYouComponent } from './components/dashboard/let-us-help-you/let-us-help-you.component';
import { LetUsHelpYouModalComponent } from './components/modals/let-us-help-you-modal/let-us-help-you-modal.component';
import { UpcomingRemindersComponent } from './components/dashboard/upcoming-reminders/upcoming-reminders.component';
import { UpcomingRemindersCardComponent } from './components/dashboard/upcoming-reminders-card/upcoming-reminders-card.component';




@NgModule({
  declarations: [
    HeaderDashboardComponent,
    DashboardComponent,
    ChartComponent,
    ReferAFriendComponent,
    DashboardSwiperComponent,
    DashboardDonorTableComponent,
    DashboardActionButtonsComponent,
    DashboardGetStartButtonsComponent,
    SharedLinkPopoverComponent,
    SurveyModalComponent,
    ActionsPopoverSurveyComponent,
    LetUsHelpYouComponent,
    LetUsHelpYouModalComponent,
    UpcomingRemindersComponent,
    UpcomingRemindersCardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbChartModule,
    IconModule,
    CoreModule,
    MdbPopoverModule,
    ClipboardModule,
    DialogModule,
    StoreModule.forFeature(fromDashboard.dashboardFeatureKey, fromDashboard.reducer),
    StoreModule.forFeature(fromSurvey.surveyFeatureKey, fromSurvey.reducer),
    EffectsModule.forFeature([DashboardEffects, SurveyEffects ]),
    MdbRatingModule,
    MdbFormsModule,
    MdbDropdownModule,
    MdbSelectModule,
    RouterModule
  ],
  exports: [DashboardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule { 
  constructor(injector:Injector){
    const DashboardElement = createCustomElement(DashboardComponent,{injector});

    try {
      customElements.define('paybee-dashboard-element', DashboardElement)
    } catch(e) {}

  }

}
